import { Palmtree } from "lucide-react";
import type { TerracePreference } from "@/types/table";

interface PlacementSelectionSummaryProps {
  terracePreference: TerracePreference;
  terraceEnabled: boolean;
  compact?: boolean;
  /** The chosen placement has no table for the current criteria: times are hidden. */
  unavailable?: boolean;
}

export function PlacementSelectionSummary({
  terracePreference,
  terraceEnabled,
  compact = false,
  unavailable = false,
}: PlacementSelectionSummaryProps) {
  const showPlacement = terraceEnabled && terracePreference !== "no_preference";
  if (!showPlacement && !unavailable) return null;

  return (
    <div className={compact ? "mb-2 space-y-1" : "mb-3 space-y-1"}>
      {showPlacement && (
        <p
          role="status"
          className={compact
            ? "flex items-center gap-1.5 text-xs font-medium text-foreground"
            : "flex items-center gap-2 text-sm font-medium text-foreground"
          }
        >
          <Palmtree className={compact ? "h-3.5 w-3.5 text-primary" : "h-4 w-4 text-primary"} aria-hidden />
          Placement : {terracePreference === "terrace" ? "En terrasse" : "En intérieur"}
        </p>
      )}
      {unavailable && (
        <p role="alert" className={compact ? "text-xs text-destructive" : "text-sm text-destructive"}>
          Aucun horaire pour ce placement.
        </p>
      )}
    </div>
  );
}
